import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApplicationSubmodule } from '@kros-sk/application-submodules';
import { HttpMockService } from '@kros-sk/core/http-mock';

export const PUBLIC_DOCUMENT_SUBMODULES_URL = '/mock/document-viewer/public-submodules';

const ALL_SUBMODULES: Record<string, ApplicationSubmodule> = {
  'received-invoice-document': { id: 'doc-001', slug: 'received-invoice-document', name: 'Dokument', icon: 'fa-heart' }
};

type SubmoduleKey = keyof typeof ALL_SUBMODULES;

const SUBMODULES_BY_MODULE: Record<string, SubmoduleKey[]> = {
  public: ['received-invoice-document'],
};

const DEFAULT_SUBMODULES: SubmoduleKey[] = ['received-invoice-document'];

@Injectable()
export class PublicDocumentSubmodulesMockService implements HttpMockService {
  get(req: HttpRequest<unknown>): ApplicationSubmodule[] | null {
    if (req.url !== PUBLIC_DOCUMENT_SUBMODULES_URL) {
      return null;
    }

    const moduleId = req.params.get('moduleId');
    const submoduleKeys = (moduleId ? SUBMODULES_BY_MODULE[moduleId] : null) ?? DEFAULT_SUBMODULES;

    return submoduleKeys.map((key) => ALL_SUBMODULES[key]);
  }
}
